import {
  Box,
  Flex,
  HStack,
  IconButton,
  List,
  ListIcon,
  ListItem,
  Spinner,
  Text,
} from '@chakra-ui/react';
import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import {
  FaCheckCircle,
  FaExclamationCircle,
  FaTimesCircle,
} from 'react-icons/fa';
import { FiFile } from 'react-icons/fi';

const DropzoneField = React.forwardRef(
  (
    {
      control,
      name,
      onChange,
      value,
      filesBeingUploaded,
      multiple = true,
      ...rest
    },
    ref
  ) => {
    const onDrop = useCallback(
      (droppedFiles, rejecedFiles) => {
        // const newFiles = (!!value?.length && [...value].concat(droppedFiles)) || droppedFiles;
        if (rejecedFiles.length === 0) {
          const newFiles = value ? [...value, ...droppedFiles] : droppedFiles;

          onChange(newFiles);
        }
      },
      [value]
    );
    const { getRootProps, getInputProps, isDragActive, fileRejections } =
      useDropzone({
        onDrop,
        multiple,
      });
    const removeFile = file => () => {
      const newFiles = [...value];
      newFiles.splice(newFiles.indexOf(file), 1);
      onChange(newFiles);
    };

    const fileStatus = file => {
      if (!filesBeingUploaded) return <ListIcon as={FiFile} color="primary" />;
      const fileBeingUploaded = filesBeingUploaded.find(
        fileBeingUploaded => fileBeingUploaded.file === file
      );
      if (!fileBeingUploaded) return <ListIcon as={FiFile} color="primary" />;

      if (fileBeingUploaded.status === 'uploading')
        return <Spinner color="primary" size={'sm'} mr={'2'} />;

      if (fileBeingUploaded.status === 'success')
        return <ListIcon as={FaCheckCircle} color="primary" />;

      if (fileBeingUploaded.status === 'error')
        return <ListIcon as={FaExclamationCircle} color="red.400" />;
    };

    return (
      <React.Fragment>
        <Flex
          border={'1.5px dashed'}
          borderColor={isDragActive ? 'primary' : 'lightGray.500'}
          rounded={'md'}
          py={'4'}
          px={'2'}
          minH={'100px'}
          align={'center'}
          justify={'center'}
          {...getRootProps()}
        >
          <div>
            <input {...getInputProps({ onChange })} />
            <Text fontSize={'sm'} textAlign={'center'}>
              {isDragActive
                ? 'Drop the files here ...'
                : "Click here to select files, or you can drag 'n' drop some files here"}
            </Text>
          </div>
        </Flex>
        {value ? (
          <List p={'4'}>
            {value.map((file, i) => (
              <ListItem key={i}>
                <HStack justify={'space-between'} align={'center'}>
                  <Box>
                    {fileStatus(file)}
                    {file.name}
                  </Box>
                  <IconButton
                    variant={'ghost'}
                    color={'red.400'}
                    icon={<FaTimesCircle />}
                    onClick={removeFile(file)}
                  />
                </HStack>
              </ListItem>
            ))}
          </List>
        ) : null}

        {fileRejections.length > 0 ? (
          <Text p={'4'}>
            Please upload only 1 file when editing a resource.
          </Text>
        ) : null}
      </React.Fragment>
    );
  }
);

export default DropzoneField;
